// Fetch list

export const FETCH = 'paymentMethods.FETCH'
export const FETCH_STARTED = 'paymentMethods.FETCH_STARTED'
export const FETCH_FULFILLED = 'paymentMethods.FETCH_FULFILLED'
export const FETCH_REJECTED = 'paymentMethods.FETCH_REJECTED'
export const FETCH_CANCELLED = 'paymentMethods.FETCH_CANCELLED'

export const SORTING_CHANGED = 'paymentMethods.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'paymentMethods.FETCH_ONE'
export const FETCH_ONE_STARTED = 'paymentMethods.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'paymentMethods.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'paymentMethods.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'paymentMethods.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'paymentMethods.SAVE'
export const SAVE_STARTED = 'paymentMethods.SAVE_STARTED'
export const SAVE_FULFILLED = 'paymentMethods.SAVE_FULFILLED'
export const SAVE_REJECTED = 'paymentMethods.SAVE_REJECTED'
export const SAVE_CANCELLED = 'paymentMethods.SAVE_CANCELLED'

// Delete

export const DELETE = 'paymentMethods.DELETE'
export const DELETE_STARTED = 'paymentMethods.DELETE_STARTED'
export const DELETE_FULFILLED = 'paymentMethods.DELETE_FULFILLED'
export const DELETE_REJECTED = 'paymentMethods.DELETE_REJECTED'
export const DELETE_CANCELLED = 'paymentMethods.DELETE_CANCELLED'

// Export

export const EXPORT = 'paymentMethods.EXPORT'
export const EXPORT_FULFILLED = 'paymentMethods.EXPORT_FULFILLED'
